import httpUtils from '../../utils/HttpUtils'

class ProjectService {

  //整包项目列表
  async getOnestopProjectList (userType = '0',supervisorId='',type='',companyId='',customerId='',status='',pageNo = 1) {
    var result = null;
    try {
      result = await httpUtils.post('/server/onestop/project/list',{userType,supervisorId,type,companyId,customerId,status,pageNo});
    } catch (e) {
      console.log('连接失败', e);
      result = {code: 1, msg: '连接失败'}
    }
    return result
  }

  //整包项目详情
  async getOnestopProjectDetail (projectId = '') {
    console.log('整包项目详情');
    var result = null;
    try {
      result = await httpUtils.post('/server/onestop/project/detail',{projectId});
    } catch (e) {
      console.log('连接失败', e);
      result = {code: 1, msg: '连接失败'}
    }
    return result
  }

  //整包项目验收阶段
  async getOnestopProjectStage (projectId = '', supervisorId = '') {
    console.log('整包项目验收阶段');
    var result = null;
    try {
      result = await httpUtils.post('/server/project/stage/list',{projectId, supervisorId});
    } catch (e) {
      console.log('连接失败', e);
      result = {code: 1, msg: '连接失败'}
    }
    return result
  }

  //整包项目验收收费列表
  async getOnestopProjectStageFee (projectId, supervisorId = '') {
    console.log('整包项目验收收费列表');
    var result = null;
    try {
      result = await httpUtils.post('/server/project/stage/fee/list',{projectId, supervisorId});
    } catch (e) {
      console.log('连接失败', e);
      result = {code: 1, msg: '连接失败'}
    }
    return result
  }


  //整包项目验收收费列表
  async confirmStageFee (id) {
      var result = null;
      try {
          result = await httpUtils.post('/server/project/stage/fee/customer/confirm',{id});
      } catch (e) {
          console.log('连接失败', e);
          result = {code: 1, msg: '连接失败'}
      }
      return result
  }

  //用户支付(发起微信支付)
  async customerPay (stageFeeId) {
    console.log('用户支付');
    var result = null;
    try {
      result = await httpUtils.post('/server/customer/project/pay',{stageFeeId});
    } catch (e) {
      console.log('连接失败', e);
      result = {code: 1, msg: '连接失败'}
    }
    return result
  }

  //提交合同明细凭证
  async saveCustomerContracts (id,contractImages,supplementalImages) {
    var result = null;
    try {
      result = await httpUtils.post('/server/onestop/project/save/customer/contracts',{id,contractImages,supplementalImages});
    } catch (e) {
      console.log('连接失败', e);
      result = {code: 1, msg: '连接失败'}
    }
    return result
  }

  //查看工地实拍信息
  async getProjectImageList (projectId='') {
    console.log('预约项目详情');
    var result = null;
    try {
      result = await httpUtils.post('/server/project/image/list',{projectId})
    } catch (e) {
      console.log('连接失败', e);
      result = {code: 1, msg: '连接失败'}
    }
    return result
  }
}
export default new ProjectService()
